const abbreviateAddress = (address?: string | null) => {
	if (!address) return ''
	const firstFour = address.slice(0, 4)
	const lastFour = address.slice(-4)
	return `${firstFour}...${lastFour}`
}

export default abbreviateAddress
